import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import search from "../service/search";
import Card from "../Components/Card";

const SearchResultPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");
  const [results, setResults] = useState([]);
  const [loading,setLoading] = useState(false)
  const timeOutRef = useRef(null);
  const abortRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!param) {
      setResults([]);
      return;
    }
    clearTimeout(timeOutRef.current);
    timeOutRef.current = setTimeout(() => {
      fetchData(param);
    }, 300);
    return () => clearTimeout(timeOutRef.current);
  }, [param]);
  const formattedPrice = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
  const fetchData = async (term) => {
    try {
        setLoading(true);
      const response = await search.get("search/cp-cycleparts", {
        params: {
          q: term,
        },
      });
      console.log("response from the api", response.data);
      setResults(response.data);
      setLoading(false);
    } catch (err) {
      console.log("error occured", err);
    }
  };
  const goToDetailsPage = (route, artNo) => {
    console.log(route[2], artNo);
    navigate(`/products/articles/${route[2].name}/${artNo}`);
  };
  return (
    <div className="bg-cp-black flex justify-center items-center">
      <section className="min-h-[calc(100vh-140px)] h-auto md:py-48 sm:py-12 flex flex-col justify-center items-center gap-10 w-[90%]">
        {/* <div className="text-cp-white">{
            results?.results?.map((item,i)=>(
                <div key={i} className="text-cp-white">{item.main.name}</div>
            ))
            }</div> */}

{loading ? 
(<div className="flex items-center justify-center bg-black p-4 gap-4">
  <div class="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-cp-green"></div>
 <p className="text-cp-white font-Manrope-bold text-lg">Suchergebnisse werden geladen...</p> 
</div>) :
(<>
            <h1 className="text-cp-white text-[20px] font-Manrope-bold"> <b>{results?.results?.length}</b> Suchergebnisse für <b>"{param}"</b></h1>
        <section className="w-full flex justify-center items-center">
          {results?.results?.length > 0 ? (
            // <main className="text-cp-white">it is working</main>
            <section
              className={`grid ${results?.results?.length === 1 ? "xs:grid-cols-[175px] md:grid-cols-[256px] xs:gap-2 md:gap-[100px]" : results?.results?.length === 2 ? "xs:grid-cols-[175px_175px] md:grid-cols-[256px_256px] xs:gap-2 md:gap-[100px]" : "xs:grid-cols-[175px_175px] md:grid-cols-[256px_256px]  lg:grid-cols-[256px_256px_256px] xs:gap-2 md:gap-[100px]"}  grid-row`}>
              {results?.results?.map((item, i) => (
                <div
                  key={i}
                  onClick={() =>
                    goToDetailsPage(
                      item?.categories[0].tree,
                      item?.main?.number,
                    )
                  }
                  className="flex flex-col cursor-pointer group  xl:transition xl:ease-in-out xl:delay-150  xl:hover:-translate-y-1 xl:hover:scale-110  xl:duration-300 border-[3px] border-cp-green">
                  <div className="md:h-[280px] xs:h-[180px] relative bg-cp-white flex justify-center items-center overflow-hidden ">
                    <img
                      src={item?.main?.images[0]?.src}
                      className="imageContainer  transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110  duration-300 mt-4 mb-10"
                    />
                    <div className="absolute inset-x-[0px] -bottom-[12px] flex flex-row justify-center items-center left-0">
                      <div
                        className="h-4 bg-cp-black w-[368px] flex float-left aspect-[1/1] lg:aspect-[1/2]  
                                        [clip-path:circle(70%_at_20%_30%)] 
                                        [shape-outside:circle(70%_at_20%_30%)]
                                        md:[clip-path:polygon(0%_0%,100%_0%,81%_100%,0%_100%)]
                                        md:[shape-outside:polygon(0%_0%,100%_0%,85%_100%,0%_100%)] 
                                        xs:[clip-path:polygon(0%_0%,100%_0%,86%_100%,0%_100%)]
                                      xs:[shape-outside:polygon(0%_0%,100%_0%,87%_100%,0%_100%)]
                                        transform -scale-x-100 xs:mt-10 md:mt-6 md:-ml-[44px] xs:-ml-[42px] items-center justify-start"></div>
                    </div>
                  </div>
                  <div className=" bg-cp-white relative text-[14px] h-[50%] flex justify-center items-center flex-col xs:gap-2 md:gap-8 px-2">
                    <div className="absolute -bottom-[6px] left-0">
                      <div class="md:w-[45px] xs:w-[40px]   overflow-hidden inline-block relative">
                        <div class="xs:h-[85px] md:h-16 bg-cp-green -rotate-45 transform origin-bottom-right"></div>
                      </div>
                    </div>
                    <div className="xs:text-[17px] md:text-[13px] font-bold  text-cp-black sm:px-0 md:px-3 font-Manrope-ExtraLight   flex justify-center items-center">
                      <div className="md:text-[16px] xs:text-[14px] xs:h-16 xl:h-10">
                        {item?.main?.name}
                      </div>
                    </div>
                    <div className="flex justify-center items-center flex-col  px-10 font-Manrope-ExtraLight">
                      <div className="md:text-[17px] xs:text-[15px]  md:group-hover:bg-cp-gray md:group-hover:bg-opacity-20 md:px-2 md:py-1">
                        {formattedPrice.format(item.main.uvp)}*
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </section>
          ) : (
            <div></div>
          )}
        </section>
</>)
}


      </section>
    </div>
  );
};

export default SearchResultPage;
